import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { getGradeOptions, redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/level-sections/LevelSectionsAction";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { LevelSectionEditForm } from "./LevelSectionEditForm";

export function LevelSectionEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");
  const [gradeOptions, setGradeOptions] = useState([]);
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, levelSection } = useSelector(
    (state) => ({
      actionsLoading: state.levelSections.actionsLoading,
      isSuccess: state.levelSections.isSuccess,
      type: state.levelSections.type,
      levelSection: state.levelSections.levelSection
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getLevelSection(id));
    return () => dispatch(actions.cleanLevelSectionsState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Kur Sınıfı";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  useEffect(() => {
    setGradeOptions(getGradeOptions(levelSection.gradeLevel));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [levelSection && levelSection.gradeLevel]);

  /** Belli Bir Kur Sınıfını Kaydeder */
  const saveLevelSection = (values) => {
    dispatch(actions.saveLevelSection(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/kur-siniflari"), 2500);
  };

  const btnRef = useRef();  
  const saveLevelSectionClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <LevelSectionEditForm
            gradeOptions={gradeOptions}
            levelSection={levelSection}
            btnRef={btnRef}
            setGradeOptions={setGradeOptions}            
            saveLevelSection={saveLevelSection}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveLevelSectionClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}